import React from 'react';
import {Badge} from '@enos/dpl';
import {observer, inject} from 'mobx-react';
import MessageDetail from './MessageDetail';
import WebsocketService from '~/services/websocketService';
import Audio from '~/components/Audio';
import './index.less';

@inject('messageStore', 'sessionStore')
@observer
class Message extends React.Component {
  handleClick = () => {
    const {messageStore} = this.props;
    messageStore.toggleMessagePoPUp(!messageStore.showMessage);
  };

  async componentDidMount() {
    const {messageStore, sessionStore} = this.props;
    messageStore.setAutoShow(!sessionStore.isMobile);
    if (sessionStore.roundRobin) {
      const frequency = sessionStore.lionConfiguration.messageFrequency ? sessionStore.lionConfiguration.messageFrequency : 10;
      messageStore.loopMessage(frequency);
    } else {
      WebsocketService.subscribe(messageStore.getNotification);
    }
  }

  componentWillUnmount() {
    this.props.messageStore.clearMessageTimer();
  }

  render() {
    const {messageStore} = this.props;
    return (
      <div className='message-icon'>
        <div className='sub' onClick={this.handleClick}>
          <Badge count={messageStore.messagesNumber}>
            <i className='dpl20_message' />
          </Badge>
        </div>
        {messageStore.showMessage && <div className='triangle' />}
        <MessageDetail env={this.props.sessionStore.emailAvaiable ? 'cloud' : 'edge'} />
        <Audio loop={messageStore.soundLoop} markSoundStatus={messageStore.markSoundStatus} disableSound={messageStore.disableSound} />
      </div>
    );
  }
}

export default Message;
